import { type FormRevision } from "@overmap-ai/common"
import { FormRevisionAttachmentService as OvermapFormRevisionAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FormRevisionAttachmentService extends OvermapFormRevisionAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL

	bulkAddForFormRevision(formRevisionId: FormRevision["uuid"], files: Record<string, File>) {
		return this.bulkAdd(
			Object.entries(files).map(([fieldId, file]) => ({
				form_revision: formRevisionId,
				field_identifier: fieldId,
				file: file,
			})),
		)
	}
}
